<template>
    <div>
        <Box  @close="cerrar(false)" :width="'800px'">
            <template #top>Registrar Vendedor</template>
            <template #center>
                <div class="nj-card">
                    <div class="nj-cols form c2">
                        <div>
                            <div class="nj-label">Nombre</div>
                            <input type="text" class="nj-text" v-model="vendedor.ven_nombre">
                        </div>
                        <div>
                            <div class="nj-label">Documento identidad</div>
                            <input type="text" class="nj-text" v-model="vendedor.ven_documento_identidad">
                        </div>
                        <div>
                            <div class="nj-label">Correo</div>
                            <input type="text" class="nj-text" v-model="vendedor.ven_correo">
                        </div>
                        <div>
                            <div class="nj-label">Teléfono</div>
                            <input type="text" class="nj-text" v-model="vendedor.ven_telefono">
                        </div>
                    </div>
                </div>
            </template>
            <template #bottom>
                <button class="nj-button c-green" @click="registrar()"><i class=" mdi-content-save"></i>Registrar</button>
            </template>
        </Box>
    </div>
</template>
<script>
import Toast from "../../util/toast"
import { Buttons, Box } from "../components"
import { VendedorService, ResponseStatus } from "../../rest"

export default {
    name: "RegistrarVendedor",
    components: {
        Box,
        Buttons
    },
    data() {
        return {
            vendedor: {
                ven_nombre: null,
                ven_capacidad: null,
                ven_placa: null,
            }
        }
    },
    methods: {
        registrar() {
            VendedorService.registrar({
                vendedor: this.vendedor
            }).then(
                response => {
                    if (ResponseStatus.isSuccess(response)) {
                        Toast.success(response.message)
                        this.cerrar(true)
                    }
                    else {
                        Toast.warn(response.message)
                    }
                },
                error => {
                    Toast.error(error)
                    console.error(`error: `, error)
                }
            )
        },
        cerrar(condition) {
            this.$emit("close", { componente: 'registrar', abrir: false, buscar: condition })
        }
    },
    mounted() {

    }
}
</script>

<style scoped></style>